// PLEASE USE THIS FOR LOGIN/SIGNUP (REACTUI STYLES WRAPPER)
// For anything else use firebase.js (modular v9)
import firebase from 'firebase/compat/app'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAq0EaZJ-l92c0Qp9rYkTKGXFIp5mtJmo0",
  authDomain: "lightning-cards-45e03.firebaseapp.com",
  projectId: "lightning-cards-45e03",
  storageBucket: "lightning-cards-45e03.appspot.com",
  messagingSenderId: "967141828200",
  appId: "1:967141828200:web:2b052d06658c1ba4fc3ddd",
  measurementId: "G-8MH4Q71P20"
};

firebase.initializeApp(firebaseConfig)

class Game {
  constructor(created, moves, players) {
    this.created = created
    this.moves = moves
    this.players = players
  }
}

export const gameConverter = {
  toFirestore: (game) => {
    return {
      created: game.created,
      moves: game.moves,
      players: game.players
    }
  },
  fromFirestore: (snap, options) => {
    const data = snap.data(options)
    return new Game(data.created, data.moves, data.players)
  }
}

export default firebase